import { getObjectId } from "../../../common/ag-grid-ts-utils"
import { getWorkShifts } from "../../../common/ag-grid-utils"
import { tSourceData } from "../../../dashboard-data/types"
import { tContext } from "../types"
import { cicoEnabledFromLockedColumns } from "../utils"
import { tFeatures } from "../../../common/types"

export const viewCicoTableButton = {
    label: "View CI/CO",
    icon: "view",
    action: "openCicoDetails",
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    disabled: (ctx: tContext, sourceData: tSourceData) => {
        const employeeLockedColumn = ctx.groupKeyInfo.find(gki => gki.colDef.field === "/employee")
        const cicoEnabled = cicoEnabledFromLockedColumns(ctx)
        return (
            (!employeeLockedColumn &&
                sourceData.timekeepingEntries?.reduce((agg, row) => {
                    if (!row.employee) return agg
                    return agg.add(getObjectId(row.employee))
                }, new Set()).size !== 1) ||
            !cicoEnabled
        )
    },
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    tooltip: (ctx: tContext, sourceData: tSourceData) => {
        const employeeLockedColumn = ctx.groupKeyInfo.find(gki => gki.colDef.field === "/employee")
        const cicoEnabled = cicoEnabledFromLockedColumns(ctx)
        if (
            !employeeLockedColumn &&
            sourceData.timekeepingEntries?.reduce((agg, row) => {
                if (!row.employee) return agg
                return agg.add(getObjectId(row.employee))
            }, new Set()).size !== 1
        )
            return "Please select one or more rows representing a single employee"
        if (!cicoEnabled) return "Clock-In/Clock-Out is disabled for this cell"
        else return "View Clock-In/Clock-Out entries for this employee"
    },
}

export const viewCicoForSelectedRowsButton = {
    label: "View CI/CO",
    icon: "view",
    action: "openCicoDetailsForSelectedRows",
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    disabled: (context: tContext) => {
        const cicoEnabled = cicoEnabledFromLockedColumns(context)
        return (
            context.selectedRows.reduce((agg, row) => agg.add(getObjectId(row.employee)), new Set()).size !== 1 ||
            !cicoEnabled
        )
    },
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    tooltip: (context: tContext) => {
        const cicoEnabled = cicoEnabledFromLockedColumns(context)
        if (context.selectedRows.reduce((agg, row) => agg.add(getObjectId(row.employee)), new Set()).size !== 1)
            return "You may only view the CI/CO data of one employee at a time"
        if (!cicoEnabled) return "Clock-In/Clock-Out disabled for this cell"
        else return "View Clock-In/Clock-Out entries for this employee"
    },
}

export const editTimecardDetailsAction = {
    label: "Edit Time Card Details",
    action: "editTimeCardDetails",
    icon: "edit",
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    disabled: (context: tContext, sourceData: tSourceData) => getWorkShifts(context, sourceData).size !== 1,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    tooltip: (context: tContext, sourceData: tSourceData) => {
        return getWorkShifts(context, sourceData).size !== 1
            ? "Please select one or more rows representing a single timecard"
            : ""
    },
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const addRowTableAction = (featureFlags: tFeatures) => ({
    label: "Add Row",
    icon: "add",
    action: "addNewRow",
    disabled: (context: tContext) => {
        if (context.settings.tableName === "Shifts and Breaks" && !featureFlags.shifts_and_breaks) {
            return true
        } else {
            return context.getCurrentGrouping() && context.getCurrentGrouping() !== "None"
        }
    },
    tooltip: (context: tContext) => {
        if (context.settings.tableName === "Shifts and Breaks" && !featureFlags.shifts_and_breaks) {
            return "The Shifts and Breaks feature must be enabled on your account to add new shifts or breaks"
        } else {
            return context.getCurrentGrouping() && context.getCurrentGrouping() !== "None"
                ? "To add a row, select a parent row " + "before clicking this button"
                : "Add an empty row to the table"
        }
    },
})

export const addEmployeeRowsTableAction = {
    label: "Add Employees",
    action: "addEmployeeRows",
    icon: "worker",
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    disabled: (context: tContext) => context.groupKeyInfo?.find(key => key.colDef.field === "/employee"),
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    tooltip: (context: tContext) =>
        context.groupKeyInfo?.find(key => key.colDef.field === "/employee")
            ? "The entries you are viewing are for a specific " +
              "employee. New employees cannot be added to this view"
            : undefined,
}
